import React, { useEffect, useState } from 'react';
import style from './style.module.scss';
import { RegexUtil } from '../../../../common/utils/regexUtil';
import NoneContent from '../../../../components/noneContent';
import { Link } from 'react-router-dom';

const MypagePointList = ({ items = [], totalCount = 0 }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (items.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, []);

  const PointItem = ({ item, i }) => {
    const items = item.items || [];
    const [expanded, setExpanded] = useState(false);

    const totalPoint = parseInt(item.get_point, 10) + parseInt(item.use_point, 10);

    let pointClass = 'point_num zero';
    if (totalPoint > 0) {
      pointClass = 'point_num';
    } else if (totalPoint < 0) {
      pointClass = 'point_num minus';
    }
    const value1 = RegexUtil.makeComma(parseInt(item.get_point / item.times));
    const value2 = RegexUtil.makeComma(parseInt(item.get_point));
    if (
        item.po_rel_table === "@item" &&
        item.po_content.includes(value1)
    ) {
      item.po_content = item.po_content.replace(value1, value2);
    }
    return (
      <div
        className='point_item_container'
        key={i}
        onClick={() => {
          setExpanded(!expanded);
        }}
      >
        <div className={'point_item'} key={`main-item-${i}`}>
          <span className='info'>
            <em className='tx'>{item.po_content}</em>
            <em className='date'>{item.last_time}</em>
          </span>
          <div className='point_num_container'>
            <span className={pointClass}>
              {totalPoint !== undefined
                ? totalPoint > 0
                  ? '+' + RegexUtil.makeComma(totalPoint)
                  : RegexUtil.makeComma(totalPoint)
                : 0}
            </span>
            <div className='img_container'>
              {items.length > 0 && (
                <img src='/images/chevron_right.svg' alt='Expand' className={expanded ? 'rotated' : ''} />
              )}
            </div>
          </div>
        </div>

        {expanded &&
          items.length > 0 &&
          items.map((subItem, subIndex) => {
            let subPointClass = 'point_num zero';
            if (parseInt(subItem.get_point, 10) > 0) {
              subPointClass = 'point_num';
            } else if (parseInt(subItem.use_point, 10) < 0) {
              subPointClass = 'point_num minus';
            }
            return (
              <div className='point_sub_item' key={`sub-item-${i}-${subIndex}`}>
                <span className='info'>
                  <em className='tx'>{subItem.po_content}</em>
                  <em className='date'>{subItem.created_at}</em>
                </span>
                <span className={subPointClass}>
                  {subItem.get_point !== undefined
                    ? subItem.get_point > 0
                      ? '+' + RegexUtil.makeComma(subItem.get_point)
                      : RegexUtil.makeComma(subItem.use_point)
                    : 0}
                </span>
                <div className='img_container' />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className='list_area'>
      <div className='tip_area'>
        <p className='tx'>※ 최대 3개월 이내의 내역만 확인 가능합니다.</p>
        <Link to={`/mypage/market?category=points`}>
          <button type='button' className='btn_charge'>
            구매하기
          </button>
        </Link>
      </div>
      {totalCount < 1 ? (
        <NoneContent title={'포인트'} />
      ) : (
        <div className='list'>
          {items.map((item, index) => (
            <PointItem item={item} i={index} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

export { MypagePointList };
